<template>
    <div class="inline-flex flex-col align-middle p-2 rounded-md border shadow h-44 w-80 justify-center items-start overflow-hidden">
        <label class="text-gray-400 font-bold text-sm flex-none">
            Thông tin tải
        </label>
        <div
            v-if="vehicles.length"
            class="flex-1 w-full overflow-auto pr-1">
            <template
                v-for="(vehicle, index) in vehicles"
                :key="index">
                <div
                    v-if="vehicle"
                    class="flex flex-col justify-center items-start w-full rounded mb-2 p-1"
                    :class="{ border: vehicles.length > 1 && index < vehicles.length - 1 }">
                    <div class="w-full truncate">
                        <label class="text-gray-600 font-bold flex-none">
                            Xe {{ vehicle.licensePlate || '...' }}
                        </label>
                        <vehicle-status
                            v-if="showStatus"
                            :status="vehicle.status" />
                    </div>
                </div>
            </template>
        </div>
        <div v-else>
            Chưa có thông tin
        </div>
    </div>
</template>
<script lang="ts" setup>
import VehicleStatus from './vehicle-status.vue'
const props = defineProps({
  vehicles: {
    type: Array<any>,
    required: true
  }
})
const store = $store()
const companyType = computed(() => store.auth.companyType)
const companyTypeOwnerPage = 'OWNER'

const showStatus = computed(() => {
  return companyType.value === companyTypeOwnerPage
})

const emits = defineEmits(['modify', 'skipped', 'change'])
const { vehicles } = toRefs(props)

onMounted(() => {})
</script>
